export default "__VITE_ASSET__DiywQHSp__"